<template>
  <div id="reset-password">
    <h2>Reset Password</h2>
    <div v-if="resetPasswordStatus == 'success'">
      <el-alert type="success" title="An email has been sent to you with a link to confirm your new password" />
    </div>
    <div v-if="resetPasswordStatus != 'success'">
      <p>Please choose a new password and we'll send you an email with a link to activate it</p>
      <el-form
        novalidate="true"
        label-width="10em"
        :label-position="formLabelPosition"
        :size="formSize"
        v-loading="resetPasswordStatus == 'pending'"
      >
        <el-form-item label="Email address" :error="errors.email">
          <el-input placeholder="Enter your email" v-model="email"></el-input>
        </el-form-item>
        <el-form-item label="New Password" :error="errors.password">
          <el-input placeholder="Enter as new password" v-model="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" :error="errors.password_confirmation">
          <el-input placeholder="Confirm your new password" v-model="password_confirmation" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="requestResetPassword">Submit</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import formMixin from '../mixins/formMixin'

  export default {
    mixins: [formMixin],
    methods: {
      requestResetPassword() {
        this.$store.commit('password/setErrors', {})
        this.$store.dispatch('password/resetPassword', {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
      }
    },
    computed: {
      ...mapState({
        resetPasswordStatus: state => state.password.status.resetPassword,
        resetPassword: state => state.password.resetPassword,
        errors: state => state.password.errors
      })
    },
    data() {
      return {
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  }
</script>
<style scoped>
  .el-alert {
    margin-bottom: 1em;
  }
  .forgot-password {
    margin-left: 10em;
    font-size: 14px;
  }
</style>
